module.exports={close:"Fermer",error:"Erreur",info:"Informations",success:"Succès",warning:"Avertissement"};